import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ContactSection } from './ContactSection';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Contact Section */}
      <div className="pt-16">
        <ContactSection />
      </div>

      <Footer />
    </div>
  );
};